import React, { Component } from 'react';
import { services } from '@comall-backend-builder/core';
import { Button as AntButton, Table, Input, Select, message, Modal as AntModal } from 'antd';

interface ISkuProps {
    visible: boolean;
    record: any;
    loading: boolean;
    columns: any;
    tableData: any;
    orderId: string;
    selectedAttributeKey: string;
    onCancel: () => void;
}
interface ISkuModal {
    orderId: string;
    visible: boolean;
    record: any;
    onCancel: () => void;
}

export class SkuModal extends Component<ISkuModal> {
    constructor(props: ISkuProps) {
        super(props);
        this.state = {
            spinning: true,
            columns: [
                {
                    title: '店铺',
                    dataIndex: 'salesShopName',
                    key: 'salesShopName',
                },
                {
                    title: 'SKN',
                    dataIndex: 'sknCode',
                    key: 'sknCode',
                },
                {
                    title: 'SKU',
                    dataIndex: 'skuCode',
                    key: 'skuCode',
                },
            ],
            options: [],
            sknCode: '',
            tableData: [],
            loading: false,
            targetSknCode: '',
            salesShopCode: '',
            rowSelection: {
                columnTitle: '选择',
                type: 'radio',
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        targetSknCode: selectedKeys[0],
                    });
                },
            },
        };
    }
    componentDidMount() {
        this.loadSknList();
    }

    async onSave() {
        const { record, orderId } = this.props;
        // @ts-ignore
        const { targetSknCode } = this.state;

        const params = [
            {
                sourceSknCode: record.sknCode,
                targetSknCode,
            },
        ];
        const res: any = await services.api.post(params, {
            apiPath: '/orderReplaceSkn/submit/' + orderId,
        });
        message.success('---操作成功---', res);
        this.props.onCancel();
    }
    loadSknList() {
        const { record } = this.props;
        this.setState({
            loading: true,
        });
        // @ts-ignore 兔子定义的参数
        const { sknCode, salesShopCode } = this.state;
        const params = {
            skuCode: record.skuCode,
            sknCode: record.sknCode,
            targetSknCode: sknCode,
            salesShopCode,
        };
        services.api
            .get(params, { apiPath: `/orderReplaceSkn/get_target_skns` })
            .then((res: any) => {
                const result = res || {};
                this.setState({
                    tableData: result.sknItemPos,
                    options: result.saleShopCodeList,
                    loading: false,
                });
            });
    }

    render() {
        const { visible } = this.props;
        // @ts-ignore
        const { columns, options, loading, tableData, rowSelection } = this.state;
        return (
            <AntModal
                visible={visible}
                title="置换sku列表"
                okText="确认"
                cancelText="取消"
                onCancel={this.props.onCancel}
                onOk={this.onSave.bind(this)}
                mask
                width={1000}
            >
                <Input
                    style={{ width: 300, marginBottom: '10px' }}
                    placeholder="请输入sknCode"
                    onChange={(v) => {
                        this.setState({
                            sknCode: v.target.value,
                        });
                    }}
                />
                <Select
                    showSearch
                    style={{ width: 300, marginLeft: 16 }}
                    placeholder="请选择店铺"
                    onChange={(val) => {
                        this.setState({
                            salesShopCode: val,
                        });
                    }}
                >
                    {options &&
                        options.map((item: any) => (
                            <Select.Option key={item.key} value={item.key}>
                                {item.value}
                            </Select.Option>
                        ))}
                </Select>
                <AntButton
                    style={{ marginLeft: 16 }}
                    type="primary"
                    onClick={this.loadSknList.bind(this)}
                >
                    查询
                </AntButton>
                <Table
                    rowSelection={rowSelection}
                    rowKey="sknCode"
                    loading={loading}
                    pagination={false}
                    columns={columns}
                    dataSource={tableData}
                />
            </AntModal>
        );
    }
}
